import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between" }
const _hoisted_2 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_3 = { class: "text-body-2 text-medium-emphasis flex-grow-1" }
const _hoisted_4 = { class: "text-caption text-disabled text-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "max-width": "780",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        color: "surface",
        rounded: "lg",
        class: "pa-6"
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center mb-6" }, [
            _createElementVNode("h2", { class: "text-h5 font-weight-bold mb-2" }, "What would you like to set up?"),
            _createElementVNode("p", { class: "text-body-2 text-medium-emphasis mb-0" }, " Pick the closest fit — then just describe it in Chat and I’ll build the rest. ")
          ], -1)),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kinds, (k) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: k.key,
                  cols: "12",
                  sm: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "background",
                      variant: "elevated",
                      elevation: "4",
                      height: "100%",
                      class: "pa-5 d-flex flex-column ga-3 kind-card",
                      onClick: ($event: any) => (_ctx.$emit('pick', k.key))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          _createVNode(_component_v_avatar, {
                            color: "primary",
                            variant: "tonal",
                            rounded: "lg",
                            size: "46"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                icon: k.icon
                              }, null, 8, ["icon"])
                            ]),
                            _: 2
                          }, 1024),
                          (k.beta)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                size: "x-small",
                                variant: "tonal",
                                color: "grey"
                              }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                  _createTextVNode("Beta")
                                ])),
                                _: 1,
                                __: [1]
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("span", _hoisted_2, _toDisplayString(k.title), 1),
                        _createElementVNode("span", _hoisted_3, _toDisplayString(k.desc), 1),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(k.tech), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-center text-caption text-disabled mt-6 mb-0" }, " Not sure? Pick anything — you can change how it works at any point, or just tell me in Chat. ", -1))
        ]),
        _: 1,
        __: [2,3]
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}